// LLM generated - Model Claude 4 Sonnet
import { useMemo } from 'react';

import { ContestAlertManager } from '../../common/ContestAlertManager';
import type { Alert } from '../interfaces/full-contest.interface';

/**
 * React hook for ContestAlertManager - automatically memoizes the instance
 *
 * @param alerts - The alerts object from contest data
 * @returns Memoized ContestAlertManager instance with business-focused methods
 *
 * @example
 * ```typescript
 * const alertManager = useAlertManager(contest?.alerts);
 * const hasServiceFeeDue = alertManager.hasServiceFeeDue();
 * const firstAlert = alertManager.getFirstServiceFeeAlert();
 * ```
 */
export function useAlertManager(alerts?: { values: Alert[] }): ContestAlertManager {
  return useMemo(() => new ContestAlertManager(alerts), [alerts]);
}
